/*
 * @Descripttion: 时间控件json
 * @version:
 * @Author: leo.liu
 * @Date: 2021-08-29 07:05:52
 * @LastEditors: qianlishi
 * @LastEditTime: 2021-09-28 14:20:30
 */
import moment from "moment"
export const widgetTime = {
  code: "widget-time",
  type: "html",
  label: "日期",
  icon: "icon-shijian",
  options: {
    // 配置
    setup: [
      // {
      //   type: "el-input-text",
      //   label: "图层名称",
      //   name: "layerName",
      //   required: false,
      //   placeholder: "",
      //   value: "时间筛选",
      // },
      {
        type: "a-range-picker",
        label: "日期范围",
        name: "value",
        required: false,
        placeholder: "",
        value: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
      },
      {
        type: "el-input-number",
        label: "字体大小",
        name: "fontSize",
        required: false,
        placeholder: "",
        value: "14",
      },
      {
        type: "",
        label: "",
        name: "timeSelector",
        required: false,
        placeholder: "",
        value: '',
      },
      // {
      //   type: "vue-color",
      //   label: "字体颜色",
      //   name: "color",
      //   required: false,
      //   placeholder: "",
      //   value: "#FAD400",
      // },
      // {
      //   type: "vue-color",
      //   label: "字体背景",
      //   name: "background",
      //   required: false,
      //   placeholder: "",
      //   value: "rgba(115,170,229,.5)",
      // },
      // {
      //   type: "el-select",
      //   label: "文字粗细",
      //   name: "fontWeight",
      //   required: false,
      //   placeholder: "",
      //   selectOptions: [
      //     { code: "normal", name: "正常" },
      //     { code: "bold", name: "粗体" },
      //     { code: "bolder", name: "特粗体" },
      //     { code: "lighter", name: "细体" },
      //   ],
      //   value: "normal",
      // },
      // {
      //   type: "el-select",
      //   label: "对齐方式",
      //   name: "textAlign",
      //   required: false,
      //   placeholder: "",
      //   selectOptions: [
      //     { code: "center", name: "居中" },
      //     { code: "left", name: "左对齐" },
      //     { code: "right", name: "右对齐" },
      //   ],
      //   value: "left",
      // },
    ],
    // 数据
    data: [],
    // 坐标
    position: [
      {
        type: "el-input-number",
        label: "左边距",
        name: "left",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "上边距",
        name: "top",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "宽度",
        name: "width",
        required: false,
        placeholder: "该容器在1920px大屏中的宽度",
        value: 256,
      },
      {
        type: "el-input-number",
        label: "高度",
        name: "height",
        required: false,
        placeholder: "该容器在1080px大屏中的高度",
        value: 32,
      },
    ],
  },
};
